import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Building } from "lucide-react";

export const PartnershipForm = ({ register }) => (
  <>
    {/* Partner Details */}
    <Card className="border-2 border-sky-400 bg-sky-50">
      <div className="bg-sky-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <Building className="h-4 w-4" />
          Partner Details
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs font-semibold">Partner Name</Label>
            <Input {...register("partner_name")} placeholder="e.g., John" className="h-9 mt-1" />
          </div>
          <div>
            <Label className="text-xs font-semibold">Partner Company</Label>
            <Input {...register("partner_company")} placeholder="e.g., ABC Storage" className="h-9 mt-1" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs font-semibold">Partner Type</Label>
            <select {...register("partner_type")} className="w-full h-9 mt-1 px-3 border rounded-md text-sm">
              <option value="Storage">Storage Company</option>
              <option value="Real Estate">Real Estate Agency</option>
              <option value="Estate Agent">Estate Agent</option>
              <option value="Letting Agent">Letting Agent</option>
              <option value="Property Management">Property Management</option>
              <option value="Housing Association">Housing Association</option>
              <option value="Furniture Store">Furniture Store</option>
              <option value="Office">Office/Business</option>
            </select>
          </div>
          <div>
            <Label className="text-xs font-semibold">Area/Location</Label>
            <Input {...register("partner_area")} placeholder="e.g., Milton Keynes" className="h-9 mt-1" />
          </div>
        </div>
      </CardContent>
    </Card>

    {/* Commission & Intro */}
    <Card className="border-2 border-emerald-400 bg-emerald-50">
      <div className="bg-emerald-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          💰 Commission & Message
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div className="bg-emerald-100 rounded-lg p-3 text-center">
          <Label className="text-xs font-semibold text-emerald-800">Commission Per Referral</Label>
          <div className="flex items-center justify-center gap-1 mt-2">
            <span className="text-2xl font-bold text-emerald-700">£</span>
            <Input 
              {...register("partner_commission")} 
              type="number"
              className="h-12 w-24 text-2xl font-bold text-center border-emerald-400"
            />
          </div>
        </div>
        <div>
          <Label className="text-xs font-semibold">Introduction Message</Label>
          <Input {...register("partner_intro_message")} className="h-9 mt-1" placeholder="I hope you are well." />
        </div>
        <div>
          <Label className="text-xs font-semibold">Closing Message</Label>
          <Textarea {...register("partner_closing_message")} className="min-h-[60px] text-sm mt-1" />
        </div>
      </CardContent>
    </Card>

    {/* Company Details */}
    <Card className="border-2 border-slate-400">
      <div className="bg-slate-700 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          🏢 Your Company Details
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div>
          <Label className="text-xs font-semibold">Director Name</Label>
          <Input {...register("partner_director_name")} className="h-9 mt-1" />
        </div>
        <div>
          <Label className="text-xs font-semibold">Services Offered</Label>
          <Input {...register("partner_services")} className="h-9 mt-1" />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">Email</Label>
            <Input {...register("partner_company_email")} className="h-8 mt-1 text-xs" />
          </div>
          <div>
            <Label className="text-xs">Website</Label>
            <Input {...register("partner_company_website")} className="h-8 mt-1 text-xs" />
          </div>
        </div>
        <div>
          <Label className="text-xs">Insurance Coverage</Label>
          <Input {...register("partner_insurance")} className="h-8 mt-1 text-xs" placeholder="£50,000" />
        </div>
      </CardContent>
    </Card>

    {/* Partnership Benefits */}
    <Card className="border-2 border-amber-400 bg-amber-50">
      <div className="bg-amber-500 px-3 py-2">
        <h3 className="font-bold text-black flex items-center gap-2 text-sm">
          🤝 Partnership Benefits
        </h3>
      </div>
      <CardContent className="p-3 space-y-2">
        <p className="text-xs text-amber-700 mb-2">Customize the benefits shown in the email:</p>
        <Input {...register("partner_benefit_1")} placeholder="Benefit 1" className="h-8 text-sm" />
        <Input {...register("partner_benefit_2")} placeholder="Benefit 2" className="h-8 text-sm" />
        <Input {...register("partner_benefit_3")} placeholder="Benefit 3" className="h-8 text-sm" />
        <Input {...register("partner_benefit_4")} placeholder="Benefit 4" className="h-8 text-sm" />
        <Input {...register("partner_benefit_5")} placeholder="Benefit 5" className="h-8 text-sm" />
      </CardContent>
    </Card>

    {/* Attachments */}
    <Card className="border-2 border-blue-300">
      <div className="bg-blue-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          📎 Attachments Notice
        </h3>
      </div>
      <CardContent className="p-3">
        <div className="flex items-center gap-2">
          <input 
            type="checkbox" 
            {...register("partner_show_attachments")}
            className="h-4 w-4 rounded border-gray-300"
          />
          <Label className="text-sm">Show "insurance and legal documents attached" notice</Label>
        </div>
        <p className="text-xs text-gray-500 mt-2">Remember to actually attach your insurance certificate and company documents when sending!</p>
      </CardContent>
    </Card>
  </>
);
